import type { NegociacaoSimulacaoState, EstadoSimulacao } from '../types';
import { ehEstadoDoAdmin } from '../utils/execucaoDoAdmin';
import { execucoesVazias, initialState, passosVazios } from './estadoInicial';

/**
 * Tudo o que pertence a uma simulação: sai junto quando ela deixa de ser a da tela. O formulário
 * e o acesso ficam.
 */
export const descartarConversa = (state: NegociacaoSimulacaoState) => {
  if (state.simulacao) state.simulacaoDescartadaId = state.simulacao.id;
  state.marcoDaSimulacao += 1;
  state.simulacao = null;
  state.eventos = [];
  state.ultimoSeq = 0;
  state.seqConhecido = 0;
  state.temMaisEventos = false;
  state.leituraFinalConcluida = false;
  state.exportacao = { carregando: false, carregados: 0, total: 0 };
  state.limpoAteSeq = 0;
  state.carregandoEventos = false;
  state.erroDosEventos = null;
  state.envio = null;
  state.avancando = false;
  state.pendentesDoAvanco = 0;
  state.erroDoAvanco = null;
  state.intencoes = {};
  state.configuracaoAlteradaEm = null;
  state.execucoes = execucoesVazias(null);
  state.passos = passosVazios(null);
};

/** Resposta de uma simulação que já não é a da tela (troca de agente, reinício) não a sobrescreve. */
export const atualizarSeForAtual = (state: NegociacaoSimulacaoState, estado: EstadoSimulacao) => {
  if (state.simulacao?.id === estado.id) state.simulacao = estado;
};

export const assumirSimulacao = (
  state: NegociacaoSimulacaoState,
  estado: EstadoSimulacao | null,
) => {
  if (estado?.id !== state.simulacao?.id) {
    descartarConversa(state);
    state.erroDoEncerramento = null;
  }
  state.simulacao = estado;
};

/**
 * Recarga da página: a simulação atual traz o agente e os dados com que começou, e o formulário
 * volta a mostrá-los (CA-25). Formulário já escolhido pela pessoa não é sobrescrito.
 */
export const recuperarFormulario = (state: NegociacaoSimulacaoState, estado: EstadoSimulacao) => {
  if (state.superficie === 'ADMIN') {
    recuperarModoDoAdmin(state, estado);
    return;
  }
  if (state.formulario.flowId !== null || estado.flowId === null) return;
  state.formulario = { flowId: estado.flowId, valores: { ...estado.parametros } };
};

/**
 * No admin o formulário já nasce com o fluxo da URL; o que a recarga devolve é o modo e os dados.
 * Modo já escolhido quer dizer que a pessoa mexeu no teste, e a escolha dela vale.
 */
const recuperarModoDoAdmin = (state: NegociacaoSimulacaoState, estado: EstadoSimulacao) => {
  if (!state.contextoAdmin || state.contextoAdmin.modo !== null || !ehEstadoDoAdmin(estado)) return;
  state.contextoAdmin.modo = estado.modo;
  state.formulario.valores = { ...estado.parametros };
};

/**
 * Simulação criada com o formulário anterior: sai da tela se uma leitura de GET /atual já a
 * trouxe, e a leitura que chegar depois não a traz de volta.
 */
export const descartarInicio = (state: NegociacaoSimulacaoState, simulacaoId: string) => {
  if (state.simulacao?.id === simulacaoId) descartarConversa(state);
  state.simulacaoDescartadaId = simulacaoId;
};

export const reiniciarContexto = (
  state: NegociacaoSimulacaoState,
  escritorioId: string | null,
): NegociacaoSimulacaoState => ({
  ...initialState,
  escritorioId,
  marcoDaSimulacao: state.marcoDaSimulacao + 1,
  versaoDoFormulario: state.versaoDoFormulario + 1,
  requisicoesDescartadas: [...state.requisicoesDescartadas, ...state.requisicoesEmVoo],
});
